import { FrontUrls } from 'Constants/FrontUrls'
import React, { lazy } from 'react'
import { Route, Switch } from 'react-router-dom'

const PartnersPersonalAccountLazy = lazy(
	() => import('Pages/partnersPersonalAccount/components/Main/index')
)

export const PartnersPersonalAccountRoutes = () => {
	return (
		<Switch>
			<Route
				path={FrontUrls.cabinet_redesign.partners_personal_account}
				key={FrontUrls.cabinet_redesign.partners_personal_account}
				component={PartnersPersonalAccountLazy}
			/>
		</Switch>
	)
}
